import type { Timezone } from './types'
import { toTimezone } from './utils'

export const useTranslateTimezone = (): ((str: string) => Timezone) => {
    const translate = (str: string): Timezone => toTimezone(str)
    return translate
}
